<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="left ">First Mariner Books edition 2020</p>
<p class="left ">Copyright © 2019 by Howard Norman</p>
<p class="left spaceabove1">All rights reserved</p>
<p class="left spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="left spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="left spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="left ">Names: Norman, Howard A., author.</p>
<p class="left ">Title: The ghost clause / Howard Norman.</p>
<p class="left ">Description: Boston ; New York : Houghton Mifflin Harcourt, 2019. |</p>
<p class="left ">Identifiers: <span class="smallcaps">LCCN</span> 2018036020 (print) | <span class="smallcaps">LCCN</span> 2018038075 (ebook) | <span class="smallcaps">ISBN</span> 9780544988064 (ebook) | <span class="smallcaps">ISBN</span> 9780544987296 (hardcover) | <span class="smallcaps">ISBN</span> 9780358305620 (paperback)</p>
<p class="left ">Subjects: | <span class="smallcaps">BISAC: FICTION</span> / Literary. | <span class="smallcaps">FICTION</span> / Family Life. | <span class="smallcaps">FICTION</span> / Occult &amp; Supernatural.</p>
<p class="left ">Classification: <span class="smallcaps">LCC</span> <span class="smallcaps">PR</span>9199.3.<span class="smallcaps">N</span>564 (ebook) | <span class="smallcaps">LCC</span> <span class="smallcaps">PR</span>9199.3.<span class="smallcaps">N</span>564 <span class="smallcaps">G</span>48 2019 (print) | <span class="smallcaps">DDC</span> 813/.54—dc23</p>
<p class="left "><span class="smallcaps">LC</span> record available at <a href="https://lccn.loc.gov/2018036020" target="_blank">https://lccn.loc.gov/2018036020</a></p>
<p class="left spaceabove1">Cover design by Martha Kennedy</p>
<p class="left ">Cover photograph © David Crunelle / EyeEm /Getty Images</p>
<p class="left ">Author photograph © Emma Norman</p>
<p class="left spaceabove1">v1.0619</p>
<p class="left spaceabove1">The author is grateful for permission to reprint “Once Later” by W. S. Merwin, collected in <em>Garden Time.</em> Copyright © 2016 by W. S. Merwin, used by permission of The Wylie Agency, LLC, and Copper Canyon Press.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?b1ea056e